import {
  getTeamMemberVacationRequests,
  getHolidaysOnDateRange,
} from "../services/vacation.service"
import { DateTime } from "luxon"
import {
  EVENT_TYPES,
  HOLIDAY_SCHEMAS,
  HOLIDAY_TYPES_IDS,
  IDS_HOLIDAY_SCHEMA,
} from "../consts/modules/vacations.consts"
import {
  getVacationRequestPriority,
  getVacationState,
} from "../utils/vacation.utils"

const useFetchTeamMemberVacationEvents = ({ selectedPeriod = [] }) => {
  const startDate = selectedPeriod[0].toISODate()
  const endDate = selectedPeriod[1].toISODate()

  const fetchVacationRequests = async () => {
    const response = await getTeamMemberVacationRequests(startDate, endDate)

    if (!response.success) {
      throw new Error(response.message)
    }

    const events = formatVacationRequests(response.result)
    return events.sort((a, b) => a.priority - b.priority)
  }

  const fetchHolidays = async () => {
    const response = await getHolidaysOnDateRange(startDate, endDate)

    if (!response.success) {
      throw new Error(response.message)
    }

    const holidayEvents = formatHolidayEvents(response.result)
    return holidayEvents
  }

  return {
    fetchVacationRequests,
    fetchHolidays,
  }
}

const formatVacationRequests = (vacationRequests) => {
  const events = vacationRequests.map((request) => ({
    ...request,
    start: parseStartDate(request.startDate),
    end: parseEndDate(request.endDate),
    title: request.vacationsMotive,
    eventType: EVENT_TYPES.VACATION,
    holidaySchema:
      request.teamMember.idHolidaySchema === IDS_HOLIDAY_SCHEMA.MEXICAN_2019 ?
        HOLIDAY_SCHEMAS.MEXICAN
      : HOLIDAY_SCHEMAS.FOREIGN,
    status: getVacationState(request, false),
    priority: getVacationRequestPriority(request),
  }))

  return events
}

const formatHolidayEvents = (holidays) => {
  const flattenedHolidays = Object.values(holidays).flat()

  const holidayEvents = flattenedHolidays.map((holiday) => {
    const isGlobalHoliday = holiday.holidayTypeId === HOLIDAY_TYPES_IDS.GLOBAL

    return {
      ...holiday,
      start: parseStartDate(holiday.date),
      end: parseEndDate(holiday.date),
      title: holiday.name,
      eventType:
        isGlobalHoliday ? EVENT_TYPES.GLOBAL_SISU : EVENT_TYPES.HOLIDAY,
      holidaySchema:
        isGlobalHoliday ? HOLIDAY_SCHEMAS.GLOBAL_SISU : HOLIDAY_SCHEMAS.MEXICAN,
    }
  })

  return holidayEvents
}

const parseDate = (isoDate) => DateTime.fromISO(isoDate?.split("T")[0] ?? "")

const parseStartDate = (isoDate) => parseDate(isoDate).startOf("day").toJSDate()

const parseEndDate = (isoDate) => parseDate(isoDate).endOf("day").toJSDate()

export default useFetchTeamMemberVacationEvents
